/* Load the global interaction layer only when the storefront needs it. */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var loader = document.currentScript;
  var source = loader && loader.getAttribute('data-taksh-src');
  try {
    var sourceUrl = new URL(source, window.location.href);
    var sameOrigin = sourceUrl.origin === window.location.origin;
    var shopifyCdn = sourceUrl.protocol === 'https:' && (
      sourceUrl.hostname === 'cdn.shopify.com' || sourceUrl.hostname.endsWith('.shopifycdn.com')
    );
    source = sameOrigin || shopifyCdn ? sourceUrl.href : '';
  } catch (error) { source = ''; }
  var state = 'idle';
  var pending;

  function markNoJsFallback() {
    document.documentElement.classList.remove('js');
    document.documentElement.classList.add('no-js');
  }

  function load() {
    if (!source) {
      markNoJsFallback();
      return Promise.reject(new Error('Invalid storefront interaction source.'));
    }
    if (state === 'loaded') return Promise.resolve();
    if (pending) return pending;
    state = 'loading';
    pending = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.onload = function () { state = 'loaded'; resolve(); };
      script.onerror = function () {
        state = 'failed';
        pending = null;
        markNoJsFallback();
        reject(new Error('Storefront interactions could not load.'));
      };
      document.head.appendChild(script);
    });
    return pending;
  }

  var clickSelector = '[data-open], [data-close], [data-hero-prev], [data-hero-next], [data-hero-dot], [data-tab-target], [data-sort-toggle], [data-sort-option], [data-facet-toggle], [data-cart-remove], [data-cart-plus], [data-cart-minus], [data-quantity-adjust], [data-atc-submit], [data-sticky-submit], [data-address-edit], [data-address-delete]';

  document.addEventListener('click', function (event) {
    if (state === 'loaded') return;
    var target = event.target.closest(clickSelector);
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    load().then(function () { target.click(); }).catch(function () {
      if (target.tagName === 'A' && target.href) window.location.assign(target.href);
    });
  }, true);

  document.addEventListener('submit', function (event) {
    if (state === 'loaded' || !event.target.matches('form.product-form, form.product-card-form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var form = event.target;
    load().then(function () { form.requestSubmit(); }).catch(function () { form.submit(); });
  }, true);

  document.addEventListener('change', function (event) {
    if (state === 'loaded' || !event.target.matches('[data-collection-sort], [data-collection-filter]')) return;
    event.stopImmediatePropagation();
    var target = event.target;
    load().then(function () { target.dispatchEvent(new Event('change', { bubbles: true })); }).catch(function () {});
  }, true);

  var warmEvents = ['pointerover', 'focusin', 'touchstart'];
  function warm(event) {
    if (!event.target.closest(clickSelector + ', form.product-form, form.product-card-form')) return;
    warmEvents.forEach(function (type) { document.removeEventListener(type, warm, true); });
    load().catch(function () {});
  }
  warmEvents.forEach(function (type) { document.addEventListener(type, warm, { capture: true, passive: true }); });

  var recommendationSections = document.querySelectorAll('[data-product-recommendations]');
  if (recommendationSections.length) {
    if ('IntersectionObserver' in window) {
      var recommendationLoader = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        recommendationLoader.disconnect();
        load().catch(function () {});
      }, { rootMargin: '500px 0px' });
      recommendationSections.forEach(function (section) { recommendationLoader.observe(section); });
    } else {
      window.addEventListener('scroll', function () { load().catch(function () {}); }, { once: true, passive: true });
    }
  }
  var dispatch = document.getElementById('dispatch-line');
  if (dispatch) {
    function updateDispatch() {
      var cutHour = parseInt(dispatch.getAttribute('data-cutoff-hour') || '16', 10);
      var before = dispatch.getAttribute('data-before') || '';
      var after = dispatch.getAttribute('data-after') || '';
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(cutHour, 0, 0, 0);
      if (cutoff <= now) {
        dispatch.textContent = after;
        return;
      }
      if (!before) {
        dispatch.textContent = '';
        return;
      }
      var minutes = Math.round((cutoff - now) / 60000);
      var hours = Math.floor(minutes / 60);
      dispatch.textContent = before.replace('{t}', hours + 'h ' + String(minutes % 60).padStart(2, '0') + 'm');
    }
    updateDispatch();
    window.setInterval(updateDispatch, 60000);
  }
})();
